import { type ComponentProps } from "react";
import { cn } from "@/service/classname.ts";

export const Menu = ({ className, ...rest }: ComponentProps<"div">) => {
  return (
    // Click handler is just event delegation for containing buttons
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
    <div
      popover="auto"
      onClick={(event) => {
        if (event.target instanceof HTMLButtonElement) {
          event.currentTarget.hidePopover();
        }
      }}
      className={cn(className, "Menu")}
      {...rest}
    />
  );
};
